import { useState } from 'react';
import { IUser } from '../common';
import { render } from '.';
import { Container, styled, useMediaQuery } from '@mui/material';
import { useReducer, useMemo } from 'react';
import { initRequestsState, requestsReducer, useGetRequests } from '../request-status-end-user';

export function ViewUser({
  user,
  tabNumber,
}: {
  user: IUser;
  tabNumber: number;
}) {
  const matchesGridBreakpoint = useMediaQuery('(min-width:60em)', {
    noSsr: true,
  });

  const [requestState, dispatchRequest] = useReducer(requestsReducer, initRequestsState);

  useGetRequests({ requestState, dispatchRequest });

  const READY_STATUSES = ['submitted', 'in_process', 'certificate_generation_in_process'];
  // has active requests if requests have submitted, in_process, or certificate_generation_in_process status
  const hasActiveRequests = requestState.requests.some(request => READY_STATUSES.includes(request.status.toLowerCase()));

  const [currentTab, setCurrentTab] = useState(tabNumber);
  const [edit, setEdit] = useState(false);


  return (
    <Container maxWidth="xl" style={{ padding: 0 }}>

      {matchesGridBreakpoint ? (
        <Articl>
          {render({
            user,
            currentTab,
            edit,
            setCurrentTab,
            setEdit,
            hasActiveRequests,
          })}
        </Articl>
      ) : (
        <article>
          {render({
            user,
            currentTab,
            edit,
            setCurrentTab,
            setEdit,
            hasActiveRequests,
          })}
        </article>
      )}
    </Container>
  );
}

const Articl = styled('article')(({ theme }) => ({
  border: '2px solid #eeeeee',
  padding: '1.5rem',
  overflow: 'hidden',
  boxShadow: 'none',
  borderRadius: '5px',
}));
